module.exports = __webpack_public_path__ + "static/img/065.77baba95.png";